<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Virology OATS Preview
    </template>
    <template #body>
      <b> {{ virologyListOATS.length }} results found on {{ virologyListOATS?.[0]?.testDate ?? 'N/A' }} </b> 
       
      <div class="sections">
        <div v-if="virologyListOATS.length === 0">
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Result"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Code"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Date"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Time"
              />
            </div>
          </div>
        </div>
        <div
          v-for="( item, index ) in virologyListOATS"
          :key="item"
        >
          <!-- <br> -->
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                v-model="item.sampleCode"
                disabled
                label="Code"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                v-model="item.testResult"
                disabled
                :label="`Test Result ${index + 1}`"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                v-model="item.testDate"
                disabled
                label="Test Date"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                v-model="item.testTime"
                disabled
                label="Test Time"
              />
            </div>
          </div>
          <hr class="lineBreak">
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>
  
  <script>
  // eslint-disable-next-line no-unused-vars
  import _ from 'lodash';
  // eslint-disable-next-line no-unused-vars
  import { ORGAN_LIST } from '../constants';
  // eslint-disable-next-line no-unused-vars
  import { RECIPIENT_VIROLOGY_LOIN_CODES, RECIPIENT_VIROLOGY_CODES_MAPPING, LIVING_DONOR_VIROLOGY_CODES_MAPPING } from "@/constants";
  
  export default {
    name: "VirologySectionDetailsEMROATS",
    props: {
      patient: {
        type: Object,
        default: null,
      },
      patientBundle: {
        type: Object,
        default: null,
      },
      patientType:{
        type: String,
        default: null
      },
      patientBundleOATS: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        virologyListOATS: this.getVirologyListOATS( this.patientBundleOATS ),
      };
      },
     mounted() {
      
      },
    methods: {
      combineProps() {
        return `${this.patient}`;
      },
      getVirologyListOATS( patientBundleOATS ) { 
        const virology_labs = patientBundleOATS.virology_labs;
        if ( !Array.isArray( virology_labs ) || virology_labs.length === 0 ) return [];
        const results = virology_labs[ 0 ]?.results ?? [];
        if ( !Array.isArray( results ) || results.length === 0 ) return [];
  
        const virologyList = [];
        for ( const item of results ) {
          virologyList.push( {
            testResult: item.positive ? 'Positive' : 'Negative',
            testDate: this._getOatsDateAdjusted( virology_labs[ 0 ].test_date )?.date,
            testTime: this._getOatsDateAdjusted( virology_labs[ 0 ].test_date )?.time,
            sampleCode: item.code,
          } );
        }
        return virologyList;
      },
      _getOatsDateAdjusted( date ) {
        const raw = date;
        if( !raw ) return null;
        const ms = Date.parse( raw );
        if( Number.isNaN( ms ) ) {
          return {
            date: raw.length >= 10 ? raw.substring( 0, 10 ) : null,
            time: raw.length >= 16 ? raw.substring( 11, 16 ) : null,
          };
        }
        const adjusted = new Date( ms - ( 4 * 60 ) * 60 * 1000 );
        const y = adjusted.getUTCFullYear();
        const mo = String( adjusted.getUTCMonth() + 1 ).padStart( 2, '0' );
        const d = String( adjusted.getUTCDate() ).padStart( 2, '0' );
        const hh = String( adjusted.getUTCHours() ).padStart( 2, '0' );
        const mm = String( adjusted.getUTCMinutes() ).padStart( 2, '0' );
        return { date: `${y}-${mo}-${d}`, time: `${hh}:${mm}` };
      }
    },
  };
  </script>
  
  <style scoped>
  
  .card {
    /* height: 100%; */
    /* height: 450px; */
  }
  
  .sectionHeading {
    background-color: rgb(59, 53, 53);
    color: white;
    padding-left: 5px;
  }
  
  .page-content .summary-card .card-header .summary-name {
    padding-left: 35px;
    padding-top: 4px;
    font-weight: 300;
  }
  
  .sections {
    font-size: 15px;
    height: 650px;
    width: 1400px;
    overflow: scroll;
    padding-left: 10px;
    padding-top: 5px;
  }
  
  .inputDisplay {
  border-style: solid;
  background-color: #F2F2F2;
  }
  
  .inputDisplayComments {
    border-style: solid;
    width: 650px;
    background-color: #F2F2F2;
  }
  
  .textArea
     {
    width: 650px;
    height: 50px;
    background-color: #F2F2F2;
  }
  
  .fieldName {
    font-weight: 700;
    font-size: 0.875rem;
    padding-top: 5.5px;
    padding-bottom: 2.5px;
  }
  
  .lineBreak {
    /* color: black;
    height: 2px; */
    background-color: rgb(59, 53, 53);
    border: 0 none;
      /* color: black; */
    height: 5px;
  }
  
  :deep(.afflo-ds-form-control) {
    width: max-content;
  }
  
  :deep(label) {
    width: max-content;
  }
  
  :deep(.comments .afflo-ds-form-control) {
    width: 500px;
  }
  
  </style>
  